import { Avatar, Box, Stack, Typography } from "@mui/material";
import Tooltip from "../../../Tooltip";
import { TUser } from "../../../../features/user/user.types";

type TMenuHeaderProps = {
  user: Partial<TUser> | null;
};

export const MenuHeader = ({ user }: TMenuHeaderProps) => {
  return (
    <Stack direction="row" alignItems="center" my={2} px={1.5} gap={1}>
      <Avatar
        src={user?.photoName}
        alt="User avatar"
        sx={{ width: 54, height: 54 }}
      />
      <Box overflow="hidden">
        <Tooltip title={user?.fullName}>
          <Typography
            variant="subtitle2"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {user?.fullName}
          </Typography>
        </Tooltip>
        <Tooltip title={user?.email}>
          <Typography
            variant="body1"
            fontWeight={400}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {user?.email}
          </Typography>
        </Tooltip>
      </Box>
    </Stack>
  );
};
